import type { Insurance } from "../hooks/api/useGetCalculationById";
import type { DashboardPolicyGroups, DashboardPolicySource } from "../types";
import {
  toFundSwitchPolicies,
  withCapital,
} from "../components/policyRecommendations/policies";

const EMPTY: DashboardPolicyGroups = {
  managedInsurances: [],
  otherInsurances: [],
  transferInsurances: [],
};

export const splitDashboardInsurances = (
  data: DashboardPolicySource | null | undefined,
  transferPolicies: Insurance[],
): DashboardPolicyGroups => {
  if (!data || !data.totalInsuranceList) return EMPTY;

  const transfer: Insurance[] = [];
  const transferIdentifiers = new Set<string>();
  [
    ...transferPolicies,
    ...(data.transferAllocation?.insurancesForTransfer?.insuranceTransferList ||
      []),
  ].forEach((ins: Insurance) => {
    if (!ins?.insuranceIdentifier) return;
    if (transferIdentifiers.has(ins.insuranceIdentifier)) return;
    transferIdentifiers.add(ins.insuranceIdentifier);
    transfer.push(ins);
  });

  const nonTransferInsurances = data.totalInsuranceList.filter(
    (insurance) => !transferIdentifiers.has(insurance.insuranceIdentifier),
  );

  const fundSwitchIdentifiers = new Set(
    toFundSwitchPolicies(data).map((policy) => policy.insuranceIdentifier),
  );

  const managed = nonTransferInsurances.filter(
    (ins) => ins.ownManagement === true,
  );
  const other = nonTransferInsurances.filter(
    (ins) =>
      ins.ownManagement !== true &&
      !fundSwitchIdentifiers.has(ins.insuranceIdentifier),
  );

  return {
    managedInsurances: managed,
    otherInsurances: other,
    transferInsurances: withCapital(transfer, data.totalInsuranceList),
  };
};
